import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

const STORAGE_KEY = 'mr-fav-rigs';

function getFavourites() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function useIsFavourite(rigId) {
  const [isFav, setIsFav] = useState(false);
  useEffect(() => {
    setIsFav(getFavourites().includes(rigId));
    const handler = () => setIsFav(getFavourites().includes(rigId));
    window.addEventListener('mr-fav-rigs-changed', handler);
    return () => window.removeEventListener('mr-fav-rigs-changed', handler);
  }, [rigId]);
  return isFav;
}

export default function FavouriteButton({ rigId, className = '' }) {
  const isFav = useIsFavourite(rigId);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const favs = getFavourites();
    const next = favs.includes(rigId) ? favs.filter((id) => id !== rigId) : [...favs, rigId];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event('mr-fav-rigs-changed'));
  };

  return (
    <button
      onClick={toggle}
      aria-label={isFav ? 'Remove from favourites' : 'Save rig'}
      className={`w-8 h-8 flex items-center justify-center bg-black/60 backdrop-blur-sm border border-white/10 hover:border-primary/40 text-white/70 hover:text-primary transition-colors ${className}`}
    >
      <Heart className={`w-4 h-4 ${isFav ? 'fill-primary text-primary' : ''}`} />
    </button>
  );
}